// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import type { RegularTable, DatagridModel } from "../types.js";

export async function expandCollapseHandler(
    model: DatagridModel,
    regularTable: RegularTable,
    event: MouseEvent,
): Promise<void> {
    const meta = regularTable.getMeta(event.target as HTMLElement);
    if (!meta || meta.type !== "row_header") return;
    const is_collapse = (event.target as Element).classList.contains(
        "psp-tree-label-collapse",
    );

    if (event.shiftKey && is_collapse) {
        model._view.set_depth(
            (meta.row_header as unknown[]).filter((x) => x !== undefined)
                .length - 2,
        );
    } else if (event.shiftKey) {
        model._view.set_depth(
            (meta.row_header as unknown[]).filter((x) => x !== undefined)
                .length - 1,
        );
    } else if (is_collapse) {
        model._view.collapse(meta.y);
    } else {
        model._view.expand(meta.y);
    }

    model._num_rows = await model._view.num_rows();
    model._num_columns = await model._view.num_columns();
    regularTable.draw();
}
